/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from "react";
import "./AllClient.css";
import { Tab, Tabs } from "react-bootstrap";
import Sidebar from "../../../Components/Dashboard/Sidebar/Sidebar";
import Header from "../../../Components/Dashboard/Header/Header";
import Loader from "../../../Components/loader/loader";
import {
  MdDelete,
  MdKeyboardArrowRight,
  MdOutlineModeEdit,
} from "react-icons/md";
import { BiHomeAlt } from "react-icons/bi";
import axios from "axios";
import { toast } from "react-toastify";
import { Apiurl, GetToken } from "../../../Utils/utils";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import { Button, Modal } from "react-bootstrap";


const AllClients = () => {
  const [loading, setLoading] = useState(false);
  const [showSidebar, setShowSidebar] = useState(true);
  const [dummy, setDummy] = useState(false);
  const [allClientsTableData, setallClientsTableData] = useState([]);
  const [allprojectData,setAllProjectData]=useState([])
  const [deleteItem, setDeleteItem] = useState(null);
  
  const [showImageModal, setShowImageModal] = useState(false);
  const handleClose = () => setShowImageModal(false);

  const LoginToken = GetToken();
  const navigate =useNavigate()

  const handleClientDataDisplay = () => {
    setLoading(true);
    const options = {
      method: "GET",
      headers: {
        "access-control-allow-origin": "*",
        "content-type": "application/json",
        authorization: `Bearer ${LoginToken}`,
      },
      url: `${Apiurl()}/Client/GetAllClients`,
    };

    axios(options)
      .then((response) => {
        setLoading(false);
        if (response.status === 200) {
          const data = JSON.parse(response?.data?.data);
          setallClientsTableData(data?.Result);
        }
      })
      .catch((error) => {
        setLoading(false);
        // console.error("Error fetching client data:", error);
      });
  };

  useEffect(() => {
    handleClientDataDisplay();
  }, []);
  const handleProjectData = () => {
    setLoading(true);
    const options = {
      method: "GET",
      headers: {
        "access-control-allow-origin": "*",
        "content-type": "application/json",
        authorization: `Bearer ${LoginToken}`,
      },
      url: `${Apiurl()}/Projects/GetAllProjects`,
    };

    axios(options)
      .then((response) => {
        setLoading(false);
        if (response.status === 200) {
          const data = JSON.parse(response?.data?.data);
          setAllProjectData(data)
          
        }
      })
      .catch((error) => {
        setLoading(false);
        // console.error("Error fetching client data:", error);
      });
  };
  useEffect(() => {
    handleProjectData();
  }, []);

  const handelEditTableData =(item,e)=>{
    navigate("/CreateClient", { state: {item,  tab:e} });

  }
  const handleOpenModal = (item) => {
    setDeleteItem(item);
    setShowImageModal(true);
  };
  const handleDeleteProject = (deleteItem) => {
    const data = {};
   data.Id = deleteItem.ProjectId

    setLoading(true);   
    const option = {
        method: "POST", 
        headers: {
            "access-control-allow-origin": "*",
            "content-type": "application/json",
            authorization: `Bearer ${LoginToken}`,
        },
        url: `${Apiurl()}/Projects/DeleteProject`,
        data: { data: JSON.stringify(data) },
    };
    axios(option)
        .then((e) => {
            setLoading(false);
            if (e?.status === 200) {
                toast.success(e?.data?.message);
                handleProjectData()
            }               
     
        })
        .catch((error) => {
            setLoading(false);
        });
};

  return (
    <>
      {loading ? <Loader /> : null}
      <Header showSidebar={showSidebar} setShowSidebar={setShowSidebar} />
      <div className="d-flex">
        <Sidebar showSidebar={showSidebar} dummy={dummy} setDummy={setDummy} />
        <section
          className={
            showSidebar
              ? "EMP-profile-main-section"
              : "EMP-profile-main-section-new"
          }
        >
          <div className="EMP-profile-all-icons">
            <div>
              <p className="MAIN-HEADING"> Client </p>
            </div>
            <div className="dashboiard-inner-header">
              <BiHomeAlt className="EMP-home-icon-header-inn" />
              <MdKeyboardArrowRight />
              <p> Client</p>
              <MdKeyboardArrowRight />
              <p> Create</p>
            </div>
          </div>
          <div className="EMP-profile-main-container">
            <div className="EMP-profile-outter-container">
              <div className="EMP-profile-inner-container">
                {/* <div className="EMP-profile-heading">
                            <p> Client</p>
                        </div> */}

                <Tabs
                  defaultActiveKey="profile"
                  id="uncontrolled-tab-example"
                  className="mb-3"
                >
                  {/* Create client start  */}

                  <Tab
                    eventKey="profile"
                    title="All Clients"
                    className="EMP-profile-inner-box-new"
                  >
                    <table className="table-of-employee-leaves table-of-admin-report">
                      <thead className="thead-of-emp-table-leaves">
                        <tr className="">
                          <th className="All-client-table-cell"> Sr. no</th>
                          <th className="All-client-table-cell">
                            {" "}
                            Client Name
                          </th>
                          <th className="All-client-table-cell">Email</th>
                          <th className="All-client-table-cell">Phone</th>
                          <th className="All-client-table-cell">Actions</th>
                        </tr>
                      </thead>
                      <tbody className="tbody-ofemp-table-leaves">
                        {allClientsTableData?.map((item, index) => {
                          return(
                            <tr key={index}>
                            <td> {index + 1}</td>
                            <td>{item?.ClientName}</td>
                            <td>{item?.Email}</td>
                            <td>{item?.Phone}</td>
                            <td className="">
                              <MdOutlineModeEdit
                                onClick={() => handelEditTableData(item, "client")}
                                className="handel-Edit-button"
                              />
                              <MdDelete
                                className="handel-delete-button"
                                // onClick={() => handleOpenModal(item)}
                              />
                            </td>
                          </tr>
                          )
                        }
                      
                        )}
                      </tbody>
                    </table>
                  </Tab>

                  {/* Create Project Start  */}
                  <Tab
                    eventKey="home"
                    title="All Projects"
                    className="EMP-profile-inner-box-new"
                  >
                         <table className="table-of-employee-leaves table-of-admin-report">
                      <thead className="thead-of-emp-table-leaves">
                        <tr className="">
                          <th className="Al-project-cell-sr-no"> Sr. no</th>
                          <th className="Al-project-cell">
                          Project Name
                          </th>
                          <th className="Al-project-cell">Client</th>
                          <th className="Al-project-cell">StartDate</th>
                          <th className="Al-project-cell">EndDate</th>

                          <th className="Al-project-cell">Actions</th>
                        </tr>
                      </thead>
                      <tbody className="tbody-ofemp-table-leaves">
                        {allprojectData?.map((item, index) => (
                          <tr key={index}>
                            <td> {index + 1}</td>
                            <td>{item?.ProjectName}</td>
                            <td>{item?.Client?.ClientName}</td>
                            <td>{item?.StartDate ? moment(item?.StartDate).format("DD MMM YYYY") : "-"}</td>
                           <td>{item?.EndDate ? moment(item?.EndDate).format("DD MMM YYYY") : "-"}</td>

                            <td className="">
                              <MdOutlineModeEdit
                                onClick={() => handelEditTableData(item,'project')} 
                                className="handel-Edit-button"
                              />  
                              <MdDelete
                                className="handel-delete-button"
                                onClick={() => handleOpenModal(item)} 
                              />
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </Tab>
                </Tabs>
              </div>
            </div>
          </div>
        </section>
        
        <Modal show={showImageModal} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title> Delete Client Data</Modal.Title>
        </Modal.Header>
        <Modal.Body>
        {deleteItem && (
            <div>
              <p> <span className="Deleteconfirmation-data">Client Name :</span>     {deleteItem?.ClientName || "-"}</p>
              <p> <span className="Deleteconfirmation-data">Email :</span>  {deleteItem?.Email ||      "-"}</p>
              <p> <span className="Deleteconfirmation-data"> Phone No :</span>  {deleteItem?.Phone ? deleteItem?.Phone : "-"}</p>
            </div>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button className="close_button-of-Resume" onClick={handleClose}>
            Close
          </Button>
          <Button
            className="DeleteButton-ofResume"
            // onClick={() => handleDeleteProject(deleteItem)}
          >
            Delete
          </Button>
        </Modal.Footer>
      </Modal>
      

      <Modal show={showImageModal} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title> Delete Project Data</Modal.Title>
        </Modal.Header>
        <Modal.Body>  
        {deleteItem && (
            <div>
           <p> <span className="Deleteconfirmation-data">Project Name :</span>     {deleteItem?.ProjectName || "-"}</p>
              <p> <span className="Deleteconfirmation-data">Client :</span>  {deleteItem?.Client?.ClientName ||      "-"}</p>
              <p> <span className="Deleteconfirmation-data"> StartDate :</span>  {deleteItem?.StartDate ? moment(deleteItem?.StartDate).format("DD MMM YYYY") : "-"}</p>
            </div>
          )}
  
        </Modal.Body>
        <Modal.Footer>
          <Button className="close_button-of-Resume" onClick={handleClose}>
            Close
          </Button>
          <Button
            className="DeleteButton-ofResume"
            onClick={() => handleDeleteProject(deleteItem)}
          >
            Delete
          </Button>
        </Modal.Footer>
      </Modal>
      
      </div>
    </>
  );
};

export default AllClients;